<template>
  <GlobalWindow
    v-loading="isUploading"
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="110px" label-suffix="：" inline>
      <el-form-item label="商品名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入商品名称" v-trim/>
      </el-form-item>
      <el-form-item v-if="form.type==2" label="商品标签" prop="labels">
        <el-input v-model="form.labels" placeholder="请输入标签，多个用“,”隔开，不超过5个" v-trim/>
      </el-form-item>
      <template v-else>
        <el-form-item label="商品分类" prop="categoryId">
          <el-select
            v-model="form.categoryId"
            placeholder="请选择所属分类"
          >
            <el-option
              v-for="item in labels()"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品品牌" prop="brandId">
          <el-select
            v-model="form.brandId"
            placeholder="请选择商品品牌"
          >
            <el-option
              v-for="item in brands()"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
      <el-form-item label="商品主图" prop="imgurl">
        <UploadAvatarImage
          :file="{ 'imgurlfull': form.imgurlfull, 'imgurl': form.imgurl }"
          @uploadSuccess="uploadAvatarSuccess"
          @uploadEnd="isUploading = false"
          @uploadBegin="isUploading = true"
        />
      </el-form-item>
      <el-form-item v-if="form.type==2" label="咖豆风味" prop="fileList">
        <UploadAvatarImage
          :file="{ 'imgurlfull': form.imgurlfull, 'imgurl': form.imgurl }"
          @uploadSuccess="uploadAvatarSuccess"
          @uploadEnd="isUploading = false"
          @uploadBegin="isUploading = true"
        />
      </el-form-item>
      <el-form-item v-else label="商品轮播图" prop="fileList">
        <UploadImage
          :fileList="form.fileList"
          @beginUpload="isUploading=true"
          @endUpload="isUploading=false"/>
      </el-form-item>
      <el-form-item label="展示价格" prop="price">
        <el-input v-model="form.price" placeholder="请输入展示价格" v-trim>
          <template slot="append">{{ form.type != 1 ? '元' : '咖豆' }}</template>
        </el-input>
      </el-form-item>
      <el-form-item v-if="form.type!=2" label="初始销量" prop="salenum">
        <el-input v-model="form.salenum" placeholder="请输入初始销量" v-trim/>
      </el-form-item>
      <el-form-item label="商品详情" prop="content">
        <RichEditor :content="{ content : form.content}"  @edit="form.content=$event" />
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import UploadImage from '@/components/common/UploadImage'
import UploadAvatarImage from '@/components/common/UploadAvatarImage'
import RichEditor from '@/components/common/RichEditor'
export default {
  name: 'OperaGoodsWindow',
  extends: BaseOpera,
  components: { GlobalWindow, UploadImage, UploadAvatarImage, RichEditor },
  data () {
    return {
      isUploading: false,
      // 表单数据
      form: {
        id: null,
        name: '',
        categoryId: '',
        brandId: '',
        price: '',
        fileList: [],
        imgurl: '',
        imgurlfull: '',
        salenum: '',
        type: 0,
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        remark: '',
        info: '',
        content: '',
        sortnum: '',
        looknum: '',
        type: '',
        status: '',
        isrec: '',
        styleImg: '',
        labels: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  inject: ['labels', 'brands'],
  created () {
    this.config({
      api: '/business/goods',
      'field.id': 'id'
    })
  },
  methods: {
    open (title, target, type) {
      this.title = title
      this.visible = true
      // debugger
      // 新建
      if (target == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form[this.configData['field.id']] = null
          this.form.type = type
        })
        return
      }
      // 编辑
      this.$nextTick(() => {
        for (const key in this.form) {
          this.form[key] = target[key]
        }
        this.form.type = type
      })
    },
    uploadAvatarSuccess(file) {
      this.form.imgurlfull = file.imgurlfull
      this.form.imgurl = file.imgurl
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/alertstyle.scss";
::v-deep .el-form-item__content {
  flex: 0.6;
}
::v-deep .el-select {
  width: 100%;
  .el-input__inner {
    width: 100%;
  }
}
</style>
